/**
 * Returns true for assignee strings that should be used as-is, without location prefix/suffix wrapping.
 * @param name The assignee or location name to check.
 * @returns Whether the name is a passthrough assignee.
 */
export function isPassthroughAssignee(name: string): boolean {
  return name.includes("!Authorization, CBO") || name.includes("Willis, Jessica");
}
